var _path, _path2, _path3, _path4, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMegaball(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 57,
    viewBox: "0 0 57 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.5 0C44.2355 0 57 12.7585 57 28.5C57 44.2415 44.2415 57 28.5 57C12.7585 57 0 44.2355 0 28.5C0 12.7645 12.7585 0 28.5 0Z",
    fill: "url(#paint0_linear_3548_73030)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.0287 43.2472C45.3197 43.2472 54.5322 34.0287 54.5322 22.7437C54.5322 11.4587 45.3197 2.21629 34.0287 2.21629C22.7377 2.21629 13.5073 11.4288 13.5073 22.7377C13.5073 34.0467 22.7257 43.2412 34.0287 43.2412V43.2472Z",
    fill: "url(#paint1_linear_3548_73030)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.9893 54.7838C34.2803 54.7838 43.4928 45.5653 43.4928 34.2803C43.4928 22.9953 34.2743 13.7529 22.9893 13.7529C11.7043 13.7529 2.47986 22.9713 2.47986 34.2743C2.47986 45.5773 11.6804 54.7778 22.9833 54.7778L22.9893 54.7838Z",
    fill: "url(#paint2_linear_3548_73030)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.9893 13.7529C20.1022 13.7529 17.3528 14.3579 14.855 15.442C13.9865 17.7122 13.5073 20.1681 13.5073 22.7377C13.5073 34.0287 22.7257 43.2412 34.0287 43.2412C36.9098 43.2412 39.6532 42.6362 42.145 41.558C43.0136 39.2939 43.4928 36.838 43.4928 34.2743C43.4928 22.9654 34.2743 13.7529 22.9893 13.7529Z",
    fill: "#FF6900"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3548_73030",
    x1: 27.326,
    y1: 25.4332,
    x2: 18.5987,
    y2: 2.66551,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF400"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3548_73030",
    x1: 13.8008,
    y1: 22.7317,
    x2: 54.8317,
    y2: 22.7317,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#FF6900"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#FF6900",
    stopOpacity: 0.81
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FF6900",
    stopOpacity: 0.23
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#FF6900",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3548_73030",
    x1: 43.4928,
    y1: 34.2683,
    x2: 2.47986,
    y2: 34.2683,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#FF6900"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#FF6900",
    stopOpacity: 0.81
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FF6900",
    stopOpacity: 0.23
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#FF6900",
    stopOpacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMegaball);
export default __webpack_public_path__ + "static/media/megaball.ed2286888b264c9d01f256dfcedf0d41.svg";
export { ForwardRef as ReactComponent };